import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "absolute h-40 right-10 inset-y-12" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-lg font-poppins font-normal text-gray-900" }
const _hoisted_5 = { class: "mt-0 h-24 flex flex-col items-baseline text-gray-900 leading-9 font-poppins-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-5xl font-extrabold tracking-tight font-poppins-bold"
}
const _hoisted_7 = {
  role: "list",
  class: "mt-0 lg:mt-4 mb-2 space-y-6"
}
const _hoisted_8 = { class: "flex h-16" }
const _hoisted_9 = { class: "text-black font-poppins text-sm" }
const _hoisted_10 = { class: "max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md" }


import HardwareImage from './HardwareImage.vue';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
  img?: string,
  imghover?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HardwareSelectorProduct',
  props: {
    isSelectedProduct: { type: Boolean },
    product: {}
  },
  emits: ["handle-select-product"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const checkDiscount = (product: Product): number => {
  if (product.name === 'Nokia WiFi Beacon 1.1 Bundle 2') {
    return 230;
  }
  if (product.name === 'Nokia WiFi Beacon 2') {
    return 129;
  }
  if (product.name === 'Nokia WiFi Beacon 2 Bundle 1') {
    return 249;
  }
  if (product.name === 'Nokia WiFi Beacon 2 Bundle 2') {
    return 379;
  }
  if (product.name === 'Nokia Beacon 3.1') {
    return 149;
  }
  if (product.name === 'Nokia Beacon 3.1 Bundle 1') {
    return 249;
  }
  return 0;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectProduct(_ctx.product))),
    class: _normalizeClass(["group relative my-2 lg:my-0 rounded-2xl flex flex-col bg-opacity-70 transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 cursor-pointer", { 'bg-opacity-100': !_ctx.isSelectedProduct, 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-1': _ctx.isSelectedProduct}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["transition ease-in-out group-hover:bg-white p-8 rounded-xl border-black border-solid border hover:border-none", [_ctx.isSelectedProduct? 'bg-white border-none' : 'bg-opacity-70 bg-white']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "absolute right-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300 h-20",
          src: _ctx.product.img
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "absolute right-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300 h-24",
          src: _ctx.product.imghover
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.product.name.toUpperCase()), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(['tracking-tight', _ctx.product.displayDiscount || checkDiscount(_ctx.product) > 0 ? 'text-decoration-line: line-through text-xl text-gray-500 font-bold' : 'text-5xl text-gray-900 font-extrabold'])
        }, "$" + _toDisplayString(checkDiscount(_ctx.product) > 0 ? checkDiscount(_ctx.product) : _ctx.product.price), 3),
        (_ctx.product.displayDiscount || checkDiscount(_ctx.product) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "$" + _toDisplayString(checkDiscount(_ctx.product) ? _ctx.product.price : _ctx.product.discountedPrice), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(HardwareImage, { product: _ctx.product }, null, 8, ["product"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.product.description), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: _normalizeClass(["cursor-pointer flex-1 text-18 group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none", [_ctx.isSelectedProduct? 'bg-transparent' : 'bg-white']])
        }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Product'), 3)
      ])
    ], 2)
  ], 2))
}
}

})